import React from 'react';
import DbtConnectionForm from '../../components/dbt/DbtConnectionForm';
import { FeatureGate } from '../../components/billing';

/**
 * NewDbtConnectionPage
 * Page for creating a new dbt connection
 */
const NewDbtConnectionPage = () => {
  return (
    <FeatureGate
      feature="dbt_enabled"
      upgradeMessage="Connect your dbt project to sync models, tests, and sources."
    >
      <div className="container mx-auto px-4 py-6">
        <DbtConnectionForm />
      </div>
    </FeatureGate>
  );
};

export default NewDbtConnectionPage;
